<template>
    <div id="app">
        <router-view />
    </div>
</template>
<script>
export default {
    mounted() {
        window.addEventListener("beforeunload", e => {
            window.scroll(0, 0);
        });
    }
};
</script>

<style lang="less">
@import "./assets/styles/rtl.less";

* {
    padding: 0;
    margin: 0;
    touch-action: pan-y;
}
div {
}
span,
p,
a {
    font-family: source-han-sans-japanese, sans-serif;
    font-style: normal;
}
#app {
    width: 100%;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    i {
        display: block;
        font-style: normal;
    }
}
body {
    width: 100%;
    background-color: #fcf6df;
}
</style>
